/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DirectedAcyclicGraphWidget } from '@widgets/directed-acyclic-graph-widget';
import {
  KanbanEditMembersModal,
  KanbanEditComplianceModal,
  KanbanWidget,
  KanbanEditRecipientsModal,
} from '@widgets/supply-chain-step-modal-widget';

import { VApplication } from '@/application';

import { SuppChainTransOverViewPageService } from '..//services';
import { Header } from '@pages/SupplyChainList/components';
import { SupplyChainStepModal } from '../components/SupllyChainStepModal';

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    'services.SuppChainTransOverViewPageService'
  ) as SuppChainTransOverViewPageService;
};
export const ContainerComm = () => {
  let location = useLocation();
  const srv = getSrv();
  let {
    NODES,
    EDGES,
    INITIAL_SUPPLIERS,
    INITIAL_COMPLIANCE_PROOF,
    INITIAL_RECIPIENTS,
    COMPLIANCE_LIST,
    RECIPIENTS_LISTS,
    SUPPLIERS_LIST,
    PROVENANCE_DATA,
  } = srv?.getGraphData();
  const [showDynamicModal, setShowDynamicModal] = useState<any>({
    key: null,
    data: null,
  });
  const [cardToShow, setCardToShow] = useState(false);
  const [cardToChangeMembers, setCardToChangeMembers] = useState<any>(null);
  const [cardToChangeCompliance, setCardToChangeCompliance] =
    useState<any>(null);
  const [cardToChangeRecipients, setCardToChangeRecipients] =
    useState<any>(null);
  const [members, setMembers] = useState<any>(INITIAL_SUPPLIERS || []);
  const [compliance, setCompliance] = useState<any>(
    INITIAL_COMPLIANCE_PROOF || []
  );
  const [recipients, setRecipients] = useState<any>(INITIAL_RECIPIENTS || []);

  const headerData = srv?.getAgent()?.formatHeaderSync(location?.state?.params);
  const handleSuppliersCardChange = (props: any) => {
    const node = NODES.find((n: any) => n.id === props.cardId);
    if (node) {
      setShowDynamicModal({
        key: node.id,
        data: {
          ...(node || {}),
          id: node.id,
          members: props.members,
          complianceProof: compliance[node.id] ? compliance[node.id] : [],
          recipients: recipients[node.id] ? recipients[node.id] : [],
        },
      });
      setCardToShow(true);
      setMembers({
        [node.id]: props.members,
      });
    }
    setCardToChangeMembers(null);
  };

  const handleComplianceCardChange = (props: any) => {
    const node = NODES.find((n: any) => n.id === props.cardId);
    if (node) {
      setShowDynamicModal({
        key: node.id,
        data: {
          ...(node || {}),
          id: node.id,
          complianceProof: props.members,
          members: members[node.id] ? members[node.id] : [],
          recipients: recipients[node.id] ? recipients[node.id] : [],
        },
      });
      setCardToShow(true);
      setCompliance({
        [node.id]: props.members,
      });
    }
    setCardToChangeCompliance(null);
  };

  const handleRecipientsCardChange = (props: any) => {
    console.log('handleRecipientsCardChange ->', props);
    const node = NODES.find((n: any) => n.id === props.cardId);
    if (node) {
      setShowDynamicModal({
        key: node.id,
        data: {
          ...(node || {}),
          id: node.id,
          complianceProof: compliance[node.id] ? compliance[node.id] : [],
          members: members[node.id] ? members[node.id] : [],
          recipients: props.members,
        },
      });
      setCardToShow(true);
      setRecipients({
        [node.id]: props.members,
      });
    }
    setCardToChangeRecipients(null);
  };

  const handleSupplyChainStepClosure = () => {
    setCardToShow(false);
    // setMembers({});
    // setCompliance({});
    setCardToChangeMembers(null);
    setCardToChangeCompliance(null);
    setShowDynamicModal({
      key: null,
      data: null,
    });
  };

  const handleNodeClick = (nodeId: string) => {
    const node = NODES.find((n: any) => n.id === nodeId);
    setShowDynamicModal({
      key: node.id,
      data: {
        ...(node || {}),
        id: node.id,
        members: members[node.id] ? members[node.id] : [],
        complianceProof: compliance[node.id] ? compliance[node.id] : [],
        recipients: recipients[node.id] ? recipients[node.id] : [],
      },
    });
    setCardToShow(true);
  };
  const handleTraceStepCB = (payload: any) => {
    console.log('trace step cb ->', payload);
  };

  const _renderHeader = () => {
    if (headerData) {
      return (
        <>
          <Header {...(headerData || {})} />
        </>
      );
    }
    return null;
  };

  return (
    <>
      {_renderHeader()}
      <DirectedAcyclicGraphWidget
        nodes={NODES}
        edges={EDGES}
        onNodeClickCB={handleNodeClick}
      />
      {cardToShow && (
        <SupplyChainStepModal
          show={cardToShow}
          key={showDynamicModal.key}
          size={'xl'}
          scrollable={true}
          fullScreen={true}
          widgetProps={showDynamicModal.data}
          onEditMembersCB={(card) => setCardToChangeMembers(card)}
          onHide={handleSupplyChainStepClosure}
          onEditComplianceCB={(card) => {
            setCardToChangeCompliance(card);
          }}
          onEditSupplyChainStepFormCB={(card) => {}}
          onEditRecipientsCB={(card) => setCardToChangeRecipients(card)}
          onUpdateTraceStepCB={handleTraceStepCB}
          provananceData={PROVENANCE_DATA}
          timelineData={PROVENANCE_DATA?.TIME_LINE_ITEMS}
        />
      )}
      {cardToChangeMembers && (
        <KanbanEditMembersModal
          show={true}
          {...cardToChangeMembers}
          availableBoardMembers={SUPPLIERS_LIST}
          onHide={() => setCardToChangeMembers(null)}
          onSubmit={handleSuppliersCardChange}
        />
      )}
      {cardToChangeCompliance && (
        <KanbanEditComplianceModal
          show={true}
          {...cardToChangeCompliance}
          members={cardToChangeCompliance?.complianceProof}
          availableBoardMembers={COMPLIANCE_LIST}
          onHide={() => setCardToChangeCompliance(null)}
          onSubmit={handleComplianceCardChange}
        />
      )}
      {cardToChangeRecipients && (
        <KanbanEditRecipientsModal
          show={true}
          {...cardToChangeRecipients}
          members={cardToChangeRecipients?.recipients}
          availableBoardMembers={RECIPIENTS_LISTS}
          onHide={() => setCardToChangeRecipients(null)}
          onSubmit={handleRecipientsCardChange}
        />
      )}
    </>
  );
};
